<template>
  <modalForm :title="$t('customers.mergeTitle')" :submit-label="$t('actions.merge')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel" fullScreen="true">
    <table class="w-full border border-collapse border-gray-200 mt-5">
      <tr>
        <td class="w-6/12">
          <CustomerPreview v-bind:customer="sourceMerge" v-bind:source="true" />
        </td>
        <td class="w-12">
          <svg class="w-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 9.09375 4.78125 L 7.6875 6.21875 L 17.46875 16 L 7.6875 25.78125 L 9.09375 27.21875 L 20.3125 16 Z M 16.09375 4.78125 L 14.6875 6.21875 L 24.46875 16 L 14.6875 25.78125 L 16.09375 27.21875 L 27.3125 16 Z"/></svg>
        </td>
        <td class="w-6/12 pl-5">
          <CustomerPreview v-bind:customer="targetMerge" v-bind:source="false" />
        </td>
      </tr>
      <tr class="border border-collapse border-gray-200">
        <td class="w-6/12">
          <CustomerReadOnlyForm v-bind:customer="sourceMerge" />
        </td>
        <td class="w-12">
          <svg class="w-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 9.09375 4.78125 L 7.6875 6.21875 L 17.46875 16 L 7.6875 25.78125 L 9.09375 27.21875 L 20.3125 16 Z M 16.09375 4.78125 L 14.6875 6.21875 L 24.46875 16 L 14.6875 25.78125 L 16.09375 27.21875 L 27.3125 16 Z"/></svg>
        </td>
        <td class="w-6/12 pl-5 pr-5">
          <div>
            {{ $t('customers.mergeTargetText') }}:
          </div>
          <div v-if="error" class="text-red-600 text-sm font-bold mt-1 mb-2">{{ error }}</div>
          <div class="mt-4">
            <p class="text-sm font-medium text-gray-700">{{ $t('customers.name') }}:</p>
            <input type="text" name="finalName" v-model="finalName" class="border border-gray-200 p-2 w-full">
            <div v-for="error of v$.finalName.$errors" :key="error.$uid">
              <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
            </div>
          </div>
          <div class="mt-4">
            <p class="text-sm font-medium text-gray-700">{{ $t('customers.phone') }}:</p>
            <input type="text" name="finalPhoneNumber" v-model="finalPhoneNumber" class="border border-gray-200 p-2 w-full">
            <div v-for="error of v$.finalPhoneNumber.$errors" :key="error.$uid">
              <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
            </div>
          </div>
          <div class="mt-4">
            <p class="text-sm font-medium text-gray-700">{{ $t('customers.avatarUrl') }}:</p>
            <input type="text" name="finalAvatar" v-model="finalAvatar" class="border border-gray-200 p-2 w-full">
            <div v-for="error of v$.finalAvatar.$errors" :key="error.$uid">
              <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import modalForm from '../building_blocks/modalForm'
import formViewMixin from '../building_blocks/formViewMixin'

import CustomerReadOnlyForm from './CustomerReadOnlyForm';
import CustomerPreview from './CustomerPreview';
import customerModel from '@/models/customer'

export default {
  mixins: [formViewMixin],
  name: 'CustomersMerge',
  props: ['sourceMerge', 'targetMerge'],
  emits: ['merge-finished-event'],
  setup () {
    return { v$: useVuelidate() }
  },
  created() {
    this.finalName = this.targetMerge.attributes.name;
    this.finalPhoneNumber = this.targetMerge.attributes['phone-number'];
    this.finalAvatar = this.targetMerge.attributes.avatar;
    if (!this.finalName) {
      this.finalName = this.sourceMerge.attributes.name;
    }
    if (!this.finalPhoneNumber) {
      this.finalPhoneNumber = this.sourceMerge.attributes['phone-number'];
    }
    if (!this.finalAvatar) {
      this.finalAvatar = this.sourceMerge.attributes.avatar;
    }
  },
  components: {
    modalForm,
    CustomerReadOnlyForm,
    CustomerPreview,
  },
  methods: {
    async onFormValid() {
      let response;
      let customerData = customerModel.buildUpdate(this.targetMerge.id, this.finalName, this.finalPhoneNumber,
          this.finalAvatar);
      try {
        response = await customerModel.updateCustomer(this.targetMerge.id, customerData, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('customers.errorUpdating');
      }
      if (response && response.status === 204) {
        this.error = '';
        await this.$root.messageEmit('merge_customers', this.$root.token, this.sourceMerge.id,
            this.targetMerge.id);
        this.$emit('merge-finished-event');
      }
    },
    cancel() {
      this.$emit('merge-finished-event');
    }
  },
  data() {
    return {
      'finalName': '',
      'finalPhoneNumber': '',
      'finalAvatar': '',
      'error': '',
    }
  },
  validations () {
    return {
      'finalName': { required },
      'finalPhoneNumber': {},
      'finalAvatar': {},
    }
  }
}
</script>
